// src/components/common/SectionTitle.js

import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ThemeContext } from '../../context/ThemeContext';
import AnimatedText from './AnimatedText';

const TitleContainer = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const Title = styled(motion.h2)`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.primary};
  position: relative;
  display: inline-block;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 3px;
    background: ${props => props.theme.accent};
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled(motion.p)`
  font-size: 1.1rem;
  color: ${props => props.theme.text};
  max-width: 700px;
  margin: 0 auto;
  margin-top: 1.5rem;
  opacity: 0.8;
`;

const SectionTitle = ({ title, subtitle }) => {
    const { theme } = useContext(ThemeContext);
    const [ref, inView] = useInView({
      triggerOnce: true,
      threshold: 0.1
    });
    
    return (
      <TitleContainer ref={ref}>
        <Title
          theme={theme}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.5 }}
        >
          <AnimatedText text={title} delay={0.1} />
        </Title>
        
        {subtitle && (
          <Subtitle
            theme={theme}
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            {subtitle}
          </Subtitle>
        )}
      </TitleContainer>
    );
  };
  
  export default SectionTitle;